import React, { Component } from 'react';

import moment from 'moment';

import ContestsService from '../../services/ContestsService';

import ContestsViewHome from './ContestsViewHome';
import ContestsViewNew from './ContestsViewNew';
import ContestsViewInfo from './ContestsViewInfo';
import ContestsViewEdit from './ContestsViewEdit';
import ContestsViewResults from './ContestsViewResults';

import NewContestView from './Contests/NewContestView';
import EditContestView from './Contests/EditContestView';
import InfoContestView from './Contests/InfoContestView';
import ResultsContestView from './contests/ResultsContestView';

export default class ContestsViewCentral extends Component {

    constructor(props) {
        super(props);

        window.zzContestsViewCentral = this;

        this.contestService = new ContestsService();

        this.state = {
            newContestForm: this.getBlankContestForm(),
            activeContestForm: this.getBlankContestForm(),
            contestData: null,
            participantType: null
        }

        this.handleScroll = this.handleScroll.bind(this);

        this.convertToDateIndex = this.convertToDateIndex.bind(this);

        this.getBlankContestForm = this.getBlankContestForm.bind(this);
        this.getExistingContestForm = this.getExistingContestForm.bind(this);

        this.startNewContest = this.startNewContest.bind(this);
        this.cancelNewContest = this.cancelNewContest.bind(this);
        this.finishNewContest = this.finishNewContest.bind(this);
        this.editNewContest = this.editNewContest.bind(this);

        this.startEditContest = this.startEditContest.bind(this);
        this.startInfoContest = this.startInfoContest.bind(this);
        this.startResultsContest = this.startResultsContest.bind(this);
        this.cancelActiveContest = this.cancelActiveContest.bind(this);
        this.saveActiveContest = this.saveActiveContest.bind(this);
        this.editActiveContest = this.editActiveContest.bind(this);

        this.organizeContests = this.organizeContests.bind(this);
    }

    handleScroll(e) {
        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    convertToDateIndex(date) {
        return parseInt(new moment(date).format('YYYYMMDD'));
    }

    getBlankContestForm() {
        return {
            type: 'raffle',
            scope: 'ca',
            clientAccountId: this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
            groupId: null,
            locationId: null,
            name: "",
            description: "",
            timeFrame: "day",
            fromDateIndex: null,
            toDateIndex: null,
            hasQualifier: false,
            qualifier: {
                masterKpiId: null,
                reportKpiId: null,
                value: "",
                isLowerBetter: false
            },
            metricCount: 1,
            metric: {
                masterKpiId: null,
                reportKpiId: null,
                value: "",
                isLowerBetter: false,
                ticketCount: 1,
                isRepeatable: false
            },
            metric2: {
                masterKpiId: null,
                reportKpiId: null,
                value: "",
                isLowerBetter: false,
                ticketCount: 1,
                isRepeatable: false
            },
            metric3: {
                masterKpiId: null,
                reportKpiId: null,
                value: "",
                isLowerBetter: false,
                ticketCount: 1,
                isRepeatable: false
            }
        }
    }

    getExistingContestForm(contest) {

        let type = contest.rankedContestId != undefined ? "ranked" : "raffle";

        let timeFrameMap = {
            CYNOW: 'day',
            CYWTD: 'week',
            CYMTD: 'month',
            CYQTD: 'quarter',
            CYYTD: 'year'
        }
        let metricCount = 1;
        if (type === "raffle") {
            if (contest.metricTwoMasterKpiId != null || contest.metricTwoReportKpiId != null) {
                metricCount = 2;

                if (contest.metricThreeMasterKpiId != null || contest.metricThreeReportKpiId != null) {
                    metricCount = 3;
                }
            }
        }

        return {
            type: type,
            scope: contest.groupId != null ? 'group' : contest.locationId != null ? 'location' : 'ca',
            clientAccountId: contest.clientAccountId,
            groupId: contest.groupId,
            locationId: contest.locationId,
            name: contest.name,
            description: contest.description,
            timeFrame: type === "ranked" ? timeFrameMap[contest.timeFrame] : "day",
            fromDateIndex: contest.fromDateIndex,
            toDateIndex: contest.toDateIndex,
            hasQualifier: contest.qualifierMasterKpiId != null || contest.qualifierReportKpiId != null,
            qualifier: {
                masterKpiId: contest.qualifierMasterKpiId,
                reportKpiId: contest.qualifierReportKpiId,
                value: contest.qualifierValue != null ? contest.qualifierValue + "" : "",
                isLowerBetter: contest.qualifierIsLowerValueBetter != null ? contest.qualifierIsLowerValueBetter : false
            },
            metricCount: metricCount,
            metric: {
                masterKpiId: type === "ranked" ? contest.metricMasterKpiId : contest.metricOneMasterKpiId,
                reportKpiId: type === "ranked" ? contest.metricReportKpiId : contest.metricOneReportKpiId,
                value: type === "ranked" ? "" : contest.metricOneValue != null ? contest.metricOneValue + "" : "",
                isLowerBetter: type === "ranked" ? contest.metricIsLowerValueBetter : contest.metricOneIsLowerValueBetter,
                ticketCount: type === "ranked" ? 1 : contest.metricOneTicketCount,
                isRepeatable: type === "ranked" ? false : contest.metricOneIsRepeatable
            },
            metric2: {
                masterKpiId: type === "ranked" ? null : contest.metricTwoMasterKpiId,
                reportKpiId: type === "ranked" ? null : contest.metricTwoReportKpiId,
                value: type === "ranked" ? "" : contest.metricTwoValue != null ? contest.metricTwoValue + "" : "",
                isLowerBetter: type === "ranked" ? false : contest.metricTwoIsLowerValueBetter != null ? contest.metricTwoIsLowerValueBetter : false,
                ticketCount: type === "ranked" ? 1 : contest.metricTwoTicketCount != null ? contest.metricTwoTicketCount : 1,
                isRepeatable: type === "ranked" ? false : contest.metricTwoIsRepeatable != null ? contest.metricTwoIsRepeatable : false
            },
            metric3: {
                masterKpiId: type === "ranked" ? null : contest.metricThreeMasterKpiId,
                reportKpiId: type === "ranked" ? null : contest.metricThreeReportKpiId,
                value: type === "ranked" ? "" : contest.metricThreeValue != null ? contest.metricThreeValue + "" : "",
                isLowerBetter: type === "ranked" ? false : contest.metricThreeIsLowerValueBetter != null ? contest.metricThreeIsLowerValueBetter : false,
                ticketCount: type === "ranked" ? 1 : contest.metricThreeTicketCount != null ? contest.metricThreeTicketCount : 1,
                isRepeatable: type === "ranked" ? false : contest.metricThreeIsRepeatable != null ? contest.metricThreeIsRepeatable : false
            }
        }
    }

    startNewContest(participantType) {

        let self = this;

        if (this.props.accountInfo != undefined) {

            this.setState({
                newContestForm: this.getBlankContestForm(),
                participantType: participantType
            }, () => {
                self.props.handleNavChange(undefined, 'new');
            });
        }
    }

    startEditContest() {

        let self = this;

        if (this.props.accountInfo != undefined) {

            this.setState({
                activeContestForm: this.getExistingContestForm(this.props.activeContest),
                participantType: this.props.activeContest.participantType
            }, () => {
                self.props.handleModeChange('edit');
            });
        }
    }

    startInfoContest() {
        let self = this;

        if (this.props.accountInfo != undefined) {

            this.setState({
                activeContestForm: this.getExistingContestForm(this.props.activeContest),
                participantType: this.props.activeContest.participantType
            }, () => {
                self.props.handleModeChange('info');
            });
        }
    }

    startResultsContest() {
        let self = this;

        if (this.props.accountInfo != undefined) {
            let contest = this.props.activeContest;

            self.props.loadingOn();

            let isRanked = contest.rankedContestId != undefined;

            let callfunc = isRanked ? "getRankedContest" : "getRaffleContest"
            let id = isRanked ? contest.rankedContestId : contest.raffleContestId
            self.contestService[callfunc](true, id, (contestData) => {
                if (contestData.data.length > 0) {

                    let data = contestData.data;

                    if (isRanked) {
                        data = _.sortBy(data, x => x.value);
                        if (!contest.metricIsLowerValueBetter) {
                            data = data.reverse();
                        }
                    } else {
                        data = _.sortBy(Object.values(data.reduce((r, e) => {
                            let key = e.entityName;
                            if (!r[key]) {
                                r[key] = e;
                            } else {
                                r[key].ticketCount += e.ticketCount;
                            }

                            return r;
                        }, {})), x => x.ticketCount)

                        data = data.reverse();
                    }

                    self.setState({
                        contestData: data
                    }, () => {
                        self.props.loadingOff();
                        self.props.handleModeChange("results");
                    })
                } else {
                    self.props.loadingOff();
                    alert("There are currently no valid contestants for this contest.");
                }
            }, (err) => {
                self.props.loadingOff();
                alert("There was an error getting contest results. Please try again.");
            })
        }
    }

    cancelNewContest() {

        let self = this;

        this.setState({
            newContestForm: this.getBlankContestForm(),
            participantType: null
        }, () => {
            self.props.handleNavChange(undefined, 'home');
        });
    }

    cancelActiveContest() {
        let self = this;

        this.setState({
            activeContestForm: this.getBlankContestForm(),
            participantType: null
        }, () => {
            self.props.handleModeChange('home');
        });
    }

    finishNewContest(callback) {
        let self = this;
        let form = this.state.newContestForm;

        let isCA = form.scope === 'ca';
        let isGroup = form.scope === 'group';
        let isLocation = form.scope === 'location';

        let usingMasterKpis = isGroup;

        let finalForm = {
            clientAccountId: form.clientAccountId,
            groupId: isGroup ? form.groupId : null,
            locationId: isLocation ? form.locationId : null,
            name: form.name,
            description: form.description,
            qualifierMasterKpiId: usingMasterKpis ? (form.hasQualifier ? form.qualifier.masterKpiId : null) : null,
            qualifierReportKpiId: usingMasterKpis ? null : (form.hasQualifier ? form.qualifier.reportKpiId : null),
            qualifierValue: form.hasQualifier ? parseFloat(form.qualifier.value) : null,
            qualifierIsLowerValueBetter: form.hasQualifier ? form.qualifier.isLowerBetter : null,
            fromDateIndex: form.fromDateIndex,
            toDateIndex: form.toDateIndex,
            employeeExclusionList: [],
            participantType: self.state.participantType
        }

        let createFunction = 'null';
        if (form.type === 'ranked') {
            createFunction = 'createRankedContest';
            let timeFrameMap = {
                day: 'CYNOW',
                week: 'CYWTD',
                month: 'CYMTD',
                quarter: 'CYQTD',
                year: 'CYYTD'
            }

            finalForm.timeFrame = timeFrameMap[form.timeFrame];
            finalForm.metricMasterKpiId = usingMasterKpis ? form.metric.masterKpiId : null;
            finalForm.metricReportKpiId = usingMasterKpis ? null : form.metric.reportKpiId;
            finalForm.metricIsLowerValueBetter = form.metric.isLowerBetter;
        } else if (form.type === 'raffle') {
            createFunction = 'createRaffleContest';

            finalForm.metricOneMasterKpiId = usingMasterKpis ? form.metric.masterKpiId : null;
            finalForm.metricOneReportKpiId = usingMasterKpis ? null : form.metric.reportKpiId;
            finalForm.metricOneValue = parseFloat(form.metric.value);
            finalForm.metricOneIsLowerValueBetter = form.metric.isLowerBetter;
            finalForm.metricOneTicketCount = parseInt(form.metric.ticketCount);
            finalForm.metricOneIsRepeatable = form.metric.isRepeatable;

            finalForm.metricTwoMasterKpiId = form.metricCount <= 1 ? null : (usingMasterKpis ? form.metric2.masterKpiId : null);
            finalForm.metricTwoReportKpiId = form.metricCount <= 1 ? null : (usingMasterKpis ? null : form.metric2.reportKpiId);
            finalForm.metricTwoValue = form.metricCount <= 1 ? null : parseFloat(form.metric2.value);
            finalForm.metricTwoIsLowerValueBetter = form.metricCount <= 1 ? null : form.metric2.isLowerBetter;
            finalForm.metricTwoTicketCount = form.metricCount <= 1 ? null : parseInt(form.metric2.ticketCount);
            finalForm.metricTwoIsRepeatable = form.metricCount <= 1 ? null : form.metric2.isRepeatable;

            finalForm.metricThreeMasterKpiId = form.metricCount <= 2 ? null : (usingMasterKpis ? form.metric3.masterKpiId : null);
            finalForm.metricThreeReportKpiId = form.metricCount <= 2 ? null : (usingMasterKpis ? null : form.metric3.reportKpiId);
            finalForm.metricThreeValue = form.metricCount <= 2 ? null : parseFloat(form.metric3.value);
            finalForm.metricThreeIsLowerValueBetter = form.metricCount <= 2 ? null : form.metric3.isLowerBetter;
            finalForm.metricThreeTicketCount = form.metricCount <= 2 ? null : parseInt(form.metric3.ticketCount);
            finalForm.metricThreeIsRepeatable = form.metricCount <= 2 ? null : form.metric3.isRepeatable;
        }

        this.props.loadingOn(() => {
            self.contestService[createFunction](finalForm, (res) => {
                alert("Contest Saved");
                self.setState({
                    newContestForm: this.getBlankContestForm(),
                    participantType: null
                }, () => {
                    if (callback) {
                        callback();
                    }
                });
                self.props.reloadPage();

            }, (err) => {
                alert("An error occurred: could not save contest");
                
                self.props.loadingOff();
            })
        });
    }

    saveActiveContest(callback) {
        let self = this;

        let form = this.state.activeContestForm;
        let contest = this.props.activeContest;

        let tmpForm = {};
        Object.keys(contest).forEach(key => {
            tmpForm[key] = contest[key];
        });

        let isCA = form.scope === 'ca';
        let isGroup = form.scope === 'group';
        let isLocation = form.scope === 'location';

        let usingMasterKpis = isGroup;


        tmpForm.description = form.description;
        tmpForm.name = form.name;

        tmpForm.groupId = isGroup ? form.groupId : null;
        tmpForm.locationId = isLocation ? form.locationId : null;

        tmpForm.qualifierMasterKpiId = usingMasterKpis ? (form.hasQualifier ? form.qualifier.masterKpiId : null) : null;
        tmpForm.qualifierReportKpiId = usingMasterKpis ? null : (form.hasQualifier ? form.qualifier.reportKpiId : null);
        tmpForm.qualifierValue = form.hasQualifier ? parseFloat(form.qualifier.value) : null;
        tmpForm.qualifierIsLowerValueBetter = form.hasQualifier ? form.qualifier.isLowerBetter : null;

        tmpForm.fromDateIndex = form.fromDateIndex;
        tmpForm.toDateIndex = form.toDateIndex;

        let editFunction = 'null';
        if (form.type === 'ranked') {
            editFunction = "editRankedContest";

            let timeFrameMap = {
                day: 'CYNOW',
                week: 'CYWTD',
                month: 'CYMTD',
                quarter: 'CYQTD',
                year: 'CYYTD'
            }

            tmpForm.timeFrame = timeFrameMap[form.timeFrame];
            tmpForm.metricMasterKpiId = usingMasterKpis ? form.metric.masterKpiId : null;
            tmpForm.metricReportKpiId = usingMasterKpis ? null : form.metric.reportKpiId;
            tmpForm.metricIsLowerValueBetter = form.metric.isLowerBetter;

        } else if (form.type === 'raffle') {
            editFunction = "editRaffleContest";

            tmpForm.metricOneMasterKpiId = usingMasterKpis ? form.metric.masterKpiId : null;
            tmpForm.metricOneReportKpiId = usingMasterKpis ? null : form.metric.reportKpiId;
            tmpForm.metricOneValue = parseFloat(form.metric.value);
            tmpForm.metricOneIsLowerValueBetter = form.metric.isLowerBetter;
            tmpForm.metricOneTicketCount = parseInt(form.metric.ticketCount);
            tmpForm.metricOneIsRepeatable = form.metric.isRepeatable;

            tmpForm.metricTwoMasterKpiId = form.metricCount <= 1 ? null : (usingMasterKpis ? form.metric2.masterKpiId : null);
            tmpForm.metricTwoReportKpiId = form.metricCount <= 1 ? null : (usingMasterKpis ? null : form.metric2.reportKpiId);
            tmpForm.metricTwoValue = form.metricCount <= 1 ? null : parseFloat(form.metric2.value);
            tmpForm.metricTwoIsLowerValueBetter = form.metricCount <= 1 ? null : form.metric2.isLowerBetter;
            tmpForm.metricTwoTicketCount = form.metricCount <= 1 ? null : parseInt(form.metric2.ticketCount);
            tmpForm.metricTwoIsRepeatable = form.metricCount <= 1 ? null : form.metric2.isRepeatable;

            tmpForm.metricThreeMasterKpiId = form.metricCount <= 2 ? null : (usingMasterKpis ? form.metric3.masterKpiId : null);
            tmpForm.metricThreeReportKpiId = form.metricCount <= 2 ? null : (usingMasterKpis ? null : form.metric3.reportKpiId);
            tmpForm.metricThreeValue = form.metricCount <= 2 ? null : parseFloat(form.metric3.value);
            tmpForm.metricThreeIsLowerValueBetter = form.metricCount <= 2 ? null : form.metric3.isLowerBetter;
            tmpForm.metricThreeTicketCount = form.metricCount <= 2 ? null : parseInt(form.metric3.ticketCount);
            tmpForm.metricThreeIsRepeatable = form.metricCount <= 2 ? null : form.metric3.isRepeatable;
        }

        this.props.loadingOn(() => {
            self.contestService[editFunction](tmpForm, (res) => {
                alert("Contest Saved");
                self.setState({
                    activeContestForm: this.getBlankContestForm(),
                    participantType: null
                }, () => {
                    if (callback) {
                        callback();
                    }
                });
                self.props.reloadPage();

            }, (err) => {
                alert("An error occurred: could not save contest");
                
                self.props.loadingOff();
            })
        });
    }

    editNewContest(newContestForm) {
        this.setState({ newContestForm: newContestForm });
    }

    editActiveContest(activeContestForm) {
        this.setState({ activeContestForm: activeContestForm });
    }

    organizeContests() {

        let organize = (contests) => {
            let contestsObj = {
                active: {
                    clientAccount: [],
                    location: [],
                    group: []
                },
                complete: {
                    clientAccount: [],
                    location: [],
                    group: []
                },
                archive: []
            };
            contests.forEach(contest => {
                // Archived
                if (contest.isArchived) {
                    contestsObj.archive.push(contest);

                    // Active
                } else if (contest.toDateIndex > this.convertToDateIndex(new Date())) {
                    if (contest.groupId != null) {
                        contestsObj.active.group.push(contest);
                    } else if (contest.locationId != null) {
                        contestsObj.active.location.push(contest);
                    } else {
                        contestsObj.active.clientAccount.push(contest);
                    }

                    // Completed
                } else {
                    if (contest.groupId != null) {
                        contestsObj.complete.group.push(contest);
                    } else if (contest.locationId != null) {
                        contestsObj.complete.location.push(contest);
                    } else {
                        contestsObj.complete.clientAccount.push(contest);
                    }
                }
            });

            contestsObj = {
                active: {
                    clientAccount: _.sortBy(contestsObj.active.clientAccount, (contest) => { return contest.name }),
                    location: _.sortBy(contestsObj.active.location, (contest) => { return contest.name }),
                    group: _.sortBy(contestsObj.active.group, (contest) => { return contest.name })
                },
                complete: {
                    clientAccount: _.sortBy(contestsObj.complete.clientAccount, (contest) => { return contest.name }),
                    location: _.sortBy(contestsObj.complete.location, (contest) => { return contest.name }),
                    group: _.sortBy(contestsObj.complete.group, (contest) => { return contest.name })
                },
                archive: _.sortBy(contestsObj.archive, (contest) => { return contest.name })
            };


            return contestsObj;
        }

        return {
            ranked: organize(this.props.rankedContests),
            raffle: organize(this.props.raffleContests)
        }
    }

    render() {

        let outerClass = "settings-sub-container";
        let outerStyle = this.props.style;
        if (this.props.mode === 'new' || this.props.mode === 'info' || this.props.mode === 'edit') {
            outerStyle.overflow = 'hidden';
        }

        let contestsObj = this.organizeContests();

        let homeClass = 'gc-sub-container';
        let homeStyle = {};
        if (this.props.mode != 'home') {
            homeClass += ' gc-sub-container--forward';
        }

        let newClass = 'gc-sub-container';
        let newStyle = { overflowY: "hidden" };
        if (this.props.mode != 'new') {
            newClass += ' gc-sub-container--back';
        }

        let editClass = 'gc-sub-container';
        let editStyle = { overflowY: "hidden" };
        if (this.props.mode != 'edit') {
            editClass += ' gc-sub-container--back';
        }

        let infoClass = 'gc-sub-container';
        let infoStyle = {};
        if (this.props.mode != 'info') {
            infoClass += ' gc-sub-container--back';
        }

        let resultsClass = 'gc-sub-container';
        let resultsStyle = {};
        if (this.props.mode != 'results') {
            resultsClass += ' gc-sub-container--back';
        }


        if (this.props.accountInfo === undefined) {
            return (
                <div className={outerClass} style={outerStyle} onScroll={this.handleScroll}></div>
            );
        }

        return (
            <div className={outerClass} style={outerStyle} onScroll={this.handleScroll}>
                <ContestsViewHome
                    accountInfo={this.props.accountInfo}
                    users={this.props.users}
                    reportKPIs={this.props.reportKPIs}
                    className={homeClass}
                    style={homeStyle}
                    contestsObj={contestsObj}
                    participantType={this.state.participantType}
                    selectedContestId={this.props.selectedContestId}
                    handleSelectContest={this.props.handleSelectContest}
                    startNewContest={this.startNewContest}
                    startEditContest={this.startEditContest}
                    startInfoContest={this.startInfoContest}
                    startResultsContest={this.startResultsContest}
                    handleDelete={this.props.handleDelete}
                    handleArchive={this.props.handleArchive}
                    handleContestActiveMode={this.props.handleContestActiveMode}
                    handleModeChange={this.props.handleModeChange}
                />
                {
                    this.props.isActive ? [
                        (<NewContestView
                            isActive={this.props.mode === 'new'}
                            className={newClass}
                            style={newStyle}
                            participantType={this.state.participantType}
                            groupMap={this.props.groupMap}
                            groupMapReverse={this.props.groupMapReverse}
                            locationMap={this.props.locationMap}
                            locationMapReverse={this.props.locationMapReverse}
                            kpiMap={this.state.participantType === "loc" ? this.props.locationKpiMap : this.props.employeeKpiMap}
                            kpiMapReverse={this.state.participantType === "loc" ? this.props.locationKpiMapReverse : this.props.employeeKpiMapReverse}
                            masterKpiMap={this.props.masterKpiMap}
                            masterKpiMapReverse={this.props.masterKpiMapReverse}
                            calendarDates={this.props.calendarDates}
                            newContestForm={this.state.newContestForm}
                            editNewContest={this.editNewContest}
                            cancelNewContest={this.cancelNewContest}
                            finishNewContest={this.finishNewContest}
                        />),
                        (<EditContestView
                            isActive={this.props.mode === 'edit'}
                            className={editClass}
                            style={editStyle}
                            participantType={this.state.participantType}
                            groupMap={this.props.groupMap}
                            groupMapReverse={this.props.groupMapReverse}
                            locationMap={this.props.locationMap}
                            locationMapReverse={this.props.locationMapReverse}
                            kpiMap={this.state.participantType === "loc" ? this.props.locationKpiMap : this.props.employeeKpiMap}
                            kpiMapReverse={this.state.participantType === "loc" ? this.props.locationKpiMapReverse : this.props.employeeKpiMapReverse}
                            masterKpiMap={this.props.masterKpiMap}
                            masterKpiMapReverse={this.props.masterKpiMapReverse}
                            calendarDates={this.props.calendarDates}
                            activeContestForm={this.state.activeContestForm}
                            editActiveContest={this.editActiveContest}
                            cancelActiveContest={this.cancelActiveContest}
                            saveActiveContest={this.saveActiveContest}
                        />),
                        (<InfoContestView
                            isActive={this.props.mode === 'info'}
                            className={infoClass}
                            style={infoStyle}
                            participantType={this.state.participantType}
                            groupMap={this.props.groupMap}
                            groupMapReverse={this.props.groupMapReverse}
                            locationMap={this.props.locationMap}
                            locationMapReverse={this.props.locationMapReverse}
                            kpiMap={this.state.participantType === "loc" ? this.props.locationKpiMap : this.props.employeeKpiMap}
                            kpiMapReverse={this.state.participantType === "loc" ? this.props.locationKpiMapReverse : this.props.employeeKpiMapReverse}
                            masterKpiMap={this.props.masterKpiMap}
                            masterKpiMapReverse={this.props.masterKpiMapReverse}
                            calendarDates={this.props.calendarDates}
                            activeContestForm={this.state.activeContestForm}
                        />),
                        (<ResultsContestView
                            isActive={this.props.mode === 'results'}
                            className={resultsClass}
                            style={resultsStyle}
                            participantType={this.state.participantType}
                            activeContest={this.props.activeContest}
                            contestData={this.state.contestData}
                            setRaffleWinner={this.props.setRaffleWinner}
                        />)
                        /*(<ContestsViewResults
                            accountInfo={this.props.accountInfo}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            className={resultsClass}
                            style={resultsStyle}
                            identity={this.props.activeContest}
                            saveContestResult={this.props.saveContestResult}
                        />) */
                    ]
                        : null
                }
            </div>
        )
    }
}